import { render, staticRenderFns } from "./PromotionResume.vue?vue&type=template&id=e38d25e6"
import script from "./PromotionResume.vue?vue&type=script&lang=js"
export * from "./PromotionResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports